module.exports = __webpack_public_path__ + "media/Images/icon-risk-purple-0ba444db642c6604b4ced9b94738d639.svg";